module.exports = __webpack_public_path__ + "static/img/VE.72c7c450.jpg";